import requests from "../../../utils/http";

//获取部门列表
export const departmentInfo = () => requests.get("/sys/api/getAllCategory");
//表单提交
export const subInfo = (data) =>
  requests.post(
    "/applicationform/add?checkKey=add&captcha=" +
      data.captcha +
      "&sfzzjc=" +
      data.sfzzjc +
      "&sfzfbj=" +
      data.sfzfbj +
      "&cookies=" +
      data.cookies,
    data
  );
//表单编辑
export const subEdit = (data) =>
  requests.post(
    "/applicationform/edit?checkKey=add&captcha=" + data.captcha,
    data
  );
//获取验证码
export const getyzmImg = (data) => requests.get("/sys/randomImage/" + data);

export const getyzmImgNew = () => requests.get("/sys/verifycode");
//上传文件
export const uploadfile = (data) => requests.post("/sys/common/upload", data);
//撤销办件
export const deleteEvent = (data) =>
  requests.post(
    "/applicationform/revoke?taskNo=" + data.taskNo + "&msg=" + data.msg,
    data
  );
//通过id查询办件详情
export const queryById = (data) =>
  requests.get("applicationform/queryById?id=" + data.id);
//查询办件列表
export const getQueryList = (data) =>
  requests.get(
    "/applicationform/list?pageNo=" + data.pageNo + "&pageSize=" + data.pageSize
  );
//通过编号查询办件
export const searchHandle = (data) =>
  requests.get(
    "/applicationform/queryByCondition?captcha=" +
      data.captcha +
      "&checkKey=" +
      data.checkKey +
      "&queryCode=" +
      data.queryCode +
      "&taskNo=" +
      data.taskNo
  );
export const getUserinfo = (data) =>
  requests.get("/applicationform/getUserFromData", data);
